import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-flex" }
const _hoisted_2 = { class: "b-unavailabilities-card__item__time" }
const _hoisted_3 = { class: "b-unavailabilities-card__item__time__day" }
const _hoisted_4 = { class: "qa-unavailability-car-month" }
const _hoisted_5 = { class: "b-unavailabilities-card__item__data" }
const _hoisted_6 = { class: "b-unavailabilities-card__item__data__period" }
const _hoisted_7 = { class: "b-unavailabilities-card__item__data__title" }
const _hoisted_8 = { class: "h-flex-center h-pr-30" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FwIcon = _resolveComponent("FwIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "b-unavailabilities-card__item qa-unavailability-card",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit("openEventPreview", { item: _ctx.item, instanceDate: _ctx.item.dt_start, instance_id: _ctx.item.id })))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.getDateDay), 1),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.getMonth), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.getTimePeriod), 1),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t(_ctx.unavailabilityTitleTranslate(_ctx.item.title))), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_FwIcon, {
        class: "h-ml-15",
        icon: "arrow-right",
        size: "10",
        color: "#213F6B"
      })
    ])
  ]))
}